import { Button } from 'components/Button'
import Styles from './NotFound.module.scss'
import { BLAZE_HOME_PATH } from 'paths'
import { ButtonLink } from 'components/Button/ButtonLink'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { generatePath } from 'react-router-dom'

const emptyGraphicUrl = new URL('./emptyGraphic.svg', import.meta.url).href

export const NotFound = () => {
  const workspaceId = useCurrentWorkspaceId()

  return (
    <div className={Styles.container}>
      <img className={Styles.image} src={emptyGraphicUrl} alt="Page not found" loading="lazy" />
      <div className={Styles.messages}>
        <div className={Styles.message}>Make sure you typed in the page correctly.</div>
        <div className={Styles.message}>If you think there is a problem, please contact us.</div>
      </div>
      <div className={Styles.buttonGroup}>
        <Button
          size="lg"
          onPress={() => {
            if (typeof window.Intercom === 'function') window.Intercom('show')
          }}
          variant="secondary"
        >
          Contact Support
        </Button>
        <ButtonLink
          size="lg"
          to={generatePath(BLAZE_HOME_PATH, {
            workspaceId,
          })}
          variant="tertiaryGreen"
        >
          Open Home
        </ButtonLink>
      </div>
    </div>
  )
}

export default NotFound
